import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Route, BrowserRouter as Router } from 'react-router-dom';

import 'app/App.scss';
import 'fonts/fonts';

import Home from 'app/screens/Home';
import Moments from 'app/screens/Moments';
import { print } from 'shared/utils/Helpers';
import Login from 'app/screens/Login';
import UpdatePassword from 'app/components/UpdatePassword';
import WebSocket from 'shared/components/WebSocket';

import { connect } from 'react-redux';
import { resizeScreen } from 'shared/actions/screenActions';
import { IntlProvider } from 'react-intl'
import { withStyles } from '@material-ui/core/styles';

import config from 'shared/config/config';


const styles = theme => ({
  app: {
    textAlign: 'center',
    height: '100%',
    background: config.pwa_stories_bg + ' !important'
  }
})

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {}
  }

  async componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions = () => {
    this.props.resizeScreen(window.innerWidth, window.innerHeight);
  }

  render() {
    const { classes, locale, messages } = this.props;

    return (
      <div className={classes.app}>
        <IntlProvider defaultLocale="en" locale={locale} messages={messages}>
          <WebSocket>
            <Router>
              <Route exact path="/">
                <Home />
              </Route>
              <Route exact path="/story/:id">
                <Home />
              </Route>
              <Route exact path="/share/:token/:story_id/:moment_id">
                <Home />
              </Route>
              <Route exact path="/login">
                <Login />
              </Route>
              <Route exact path="/update_password/:token">
                <UpdatePassword />
              </Route>
            </Router>
          </WebSocket>
        </IntlProvider>
      </div>
    );
  }
}

App.propTypes = {
  resizeScreen: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  user: state.userReducer.user,
  messages: state.messagesReducer.messages,
  locale: state.messagesReducer.locale,
  screenWidth: state.screenReducer.dimensions.width,
  screenHeight: state.screenReducer.dimensions.height
});

export default connect(mapStateToProps, { resizeScreen })(withStyles(styles, { withTheme: true })(App));
